import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CandyService } from '../../candy.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['../login/login.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  token: string = null;
  email: string = null;
  password: string = null;
  passwordConfirmation: string = null;
  isSubmitting = false;
  isReset = false;
  errorMessage: string = null;

  constructor(
    private candy: CandyService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.token = this.route.snapshot.queryParamMap.get('token');
    this.email = this.route.snapshot.queryParamMap.get('email');

    if (!this.token || !this.email) {
      this.errorMessage = 'Invalid password reset link.';
    }
  }

  submit() {
    this.isSubmitting = true;
    this.errorMessage = null;

    this.candy.createRequest('POST', 'api/dashboard/modules/admin-user/reset-password', {
      email: this.email,
      token: this.token,
      password: this.password,
      password_confirmation: this.passwordConfirmation,
    }).subscribe(() => {
      this.isReset = true;
      this.isSubmitting = false;
    }, error => {
      this.errorMessage = this.extractError(error);
      this.isSubmitting = false;
    });
  }

  private extractError(error): string {
    const validationErrors = error?.error?.errors;
    if (validationErrors) {
      return validationErrors[Object.keys(validationErrors)[0]][0];
    }

    return error?.error?.message || 'Something went wrong!';
  }
}
